/**
 * Whether a memo pop-up is on screen. What's new reads it and waits, so a
 * release note never stacks on top of a memo the agent must confirm.
 */
import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set();

export function setMemoGateOpen(value) {
  if (open === value) return;
  open = value;
  listeners.forEach((fn) => fn());
}

const subscribe = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const useMemoGateOpen = () => useSyncExternalStore(subscribe, () => open);
